import { InputArray, InputFieldGroup } from '@reapitform/common-ui'
import { schemaDefaultSpecialTerms } from '../../../../api/defaults/links'
import React from 'react'
import { IDefaultSpecialTerms, TSpecialTermsSchema } from '../../../../api/types'
import { elWFull, FormLayout, InputGroup, InputWrapFull, Label, TextArea } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { css, cx } from '@linaria/core'
import { Control, FieldValues, FormProvider, useForm, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

const clauseStyle = css`
  resize: none;
  height: 6rem;
  min-height: unset !important;
`
interface ISpecialConditionsFormProps {
  formId: string
  defaultValues?: IDefaultSpecialTerms
  onSubmit: (data: TSpecialTermsSchema) => void
}

export const SpecialConditionsForm: React.FC<ISpecialConditionsFormProps> = ({ formId, defaultValues, onSubmit }) => {
  const formMethod = useForm<TSpecialTermsSchema>({
    defaultValues: {
      ...defaultValues,
      clauses: defaultValues?.clauses?.map((clause) => ({ value: clause })) ?? [{ value: '' }],
    },
    resolver: yupResolver(schemaDefaultSpecialTerms),
  })

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = formMethod

  const clausesError = errors.clauses?.message ?? errors.clauses?.root?.message

  return (
    <ErrorBoundary>
      <form id={formId} onSubmit={handleSubmit(onSubmit)} className={elWFull}>
        <InputFieldGroup title="Details">
          <FormLayout hasMargin>
            <InputWrapFull>
              <InputGroup
                label="Title *"
                placeholder="Template title"
                {...register('title')}
                errorMessage={errors.title?.message}
                maxLength={100}
              />
            </InputWrapFull>
            <InputWrapFull>
              <InputGroup
                hasError={Boolean(errors.useAsDefault)}
                inputAddOnText="Add by default to all agreements"
                type="checkbox"
                checked={watch('useAsDefault')}
                onChange={() => setValue('useAsDefault', !watch('useAsDefault'))}
              />
            </InputWrapFull>
          </FormLayout>
        </InputFieldGroup>
        <FormProvider {...formMethod}>
          <InputArray
            formControl={formMethod.control as unknown as Control<FieldValues, any>}
            title="Clauses"
            formFieldDefaultValue={{ value: '' }}
            addButtonText="Add Clause"
            isRequired
            minLength={1}
            fieldName="clauses"
            errorMessage={clausesError}
            RenderArrayFeld={({ fieldName, index }) => {
              const { register } = useFormContext()
              return (
                <FormLayout>
                  <InputWrapFull>
                    <InputGroup>
                      <TextArea
                        {...register(`${fieldName}.value`)}
                        placeholder="Add Clause"
                        type="text"
                        className={cx(clauseStyle, clausesError && 'el-text-area-has-error')}
                      />
                      <Label>Clause {index + 1}</Label>
                    </InputGroup>
                  </InputWrapFull>
                </FormLayout>
              )
            }}
          />
        </FormProvider>
      </form>
    </ErrorBoundary>
  )
}
